import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import {
	cardsParentSetSuccess,
	cardsParentSetFailure,
	CARDS_PARENT_SET_OPTIMISTIC,
	type CardsParentSetOptimisticAction,
} from '../../state/actions/cards/parent/index.tsx';
import { cardRefreshRequest } from '../../state/actions/cards/refresh/index.tsx';
import { getCards } from '../../state/selectors/cards/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';

export default function cardsParentSetEpic(action$: ActionsObservable, store: MiddlewareAPI) {
	return action$
		.ofType(CARDS_PARENT_SET_OPTIMISTIC)
		.mergeMap((action: CardsParentSetOptimisticAction) => {
			const {
				payload: { cards, parentId },
				meta: { optimistic },
			} = action;
			const cardEntities = getCards(store.getState());

			const changedCardIds = cards
				.filter(({ id }) => {
					const card = cardEntities[id];
					return card?.parentId !== parentId;
				})
				.map((card) => card.id);

			if (changedCardIds.length === 0) {
				return Observable.of(cardsParentSetSuccess(optimistic.id, { cards }));
			}

			return Observable.fromPromise(action.payload.requestPromise)
				.flatMap(() => Observable.of(cardsParentSetSuccess(optimistic.id, { cards })))
				.catch((error: FetchError) => {
					log.safeErrorWithoutCustomerData(
						'cards.parent-set.failure',
						'Failed to set card parent',
						error,
					);

					const actions = changedCardIds.map((cardId) => cardRefreshRequest(cardId));

					return Observable.from([cardsParentSetFailure(optimistic.id), ...actions]);
				});
		});
}
